import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Piko } from '../components/Piko';
import { api } from '../core/api';
import { useEntitlement } from '../core/entitlement';

export function PaymentSuccess() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { refresh } = useEntitlement();
  const [status, setStatus] = useState('checking');
  const tries = useRef(0);

  useEffect(() => {
    const sid = params.get('session_id');
    if (!sid) { setStatus('error'); return; }
    const poll = async () => {
      tries.current += 1;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === 'paid') { await refresh(); setStatus('paid'); return; }
        if (['failed', 'expired'].includes(r.data.payment_status)) { setStatus('failed'); return; }
      } catch {}
      if (tries.current < 12) setTimeout(poll, 2500);
      else setStatus('pending');
    };
    poll();
  }, []); // eslint-disable-line

  return <ResultShell status={status} nav={nav} />;
}

export function PaymentCancel() {
  const nav = useNavigate();
  return <ResultShell status="cancelled" nav={nav} />;
}

export function FpxResult() {
  const nav = useNavigate();
  const { refresh } = useEntitlement();
  const [status, setStatus] = useState('checking');
  const tries = useRef(0);

  useEffect(() => {
    const billId = localStorage.getItem('pp_last_bill');
    if (!billId) { setStatus('pending'); return; }
    const poll = async () => {
      tries.current += 1;
      try {
        const r = await api.get(`/billing/billplz/payment-status?bill_id=${billId}`);
        if (r.data.payment_status === 'paid') { await refresh(); setStatus('paid'); return; }
      } catch {}
      if (tries.current < 10) setTimeout(poll, 3000);
      else setStatus('pending');
    };
    poll();
  }, []); // eslint-disable-line

  return <ResultShell status={status} nav={nav} />;
}

const MSG = {
  checking: ['Menyemak pembayaran…', 'Checking payment…'],
  paid: ['Terima kasih! Pro telah diaktifkan.', 'Thank you! Pro is now active.'],
  pending: ['Pembayaran belum disahkan. Semak semula di Urus Pro sebentar lagi.', 'Payment not confirmed yet. Recheck in Manage Pro shortly.'],
  failed: ['Pembayaran tidak berjaya. Tiada caj dibuat.', 'Payment unsuccessful. No charge was made.'],
  cancelled: ['Pembayaran dibatalkan. Tiada caj dibuat.', 'Payment cancelled. No charge was made.'],
  error: ['Ralat. Sila semak di Urus Pro.', 'Error. Please check Manage Pro.'],
};

function ResultShell({ status, nav }) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-6 px-6 text-center" style={{ background: 'linear-gradient(180deg,#FCF9F2,#E2D4F0)' }} data-testid={`payment-result-${status}`}>
      <Piko pose={status === 'paid' ? 'celebrate' : 'think'} size={130} />
      <p className="font-heading text-xl font-bold text-navy max-w-sm">{MSG[status]?.[0]}</p>
      <p className="font-body text-navy/60">{MSG[status]?.[1]}</p>
      {status === 'checking' && <div className="w-8 h-8 border-4 border-sunshine border-t-transparent rounded-full animate-spin" />}
      <button data-testid="payment-back-btn" onClick={() => nav('/parent?tab=upgrade')}
        className="font-body font-bold text-white bg-navy rounded-full px-6 py-3 min-h-[48px]">Kembali ke Mod Ibu Bapa</button>
    </div>
  );
}
